module.exports = __webpack_public_path__ + "img/layout_bottom_icon.e2890766.svg";